// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header .page-header {
  padding: 0;
  border-bottom: 2px solid #137CBD;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);
  color: #137CBD;
  font-size: 1.2em;
}
header .page-header .ant-page-header-heading-left {
  margin-block: unset;
}
header .page-header .ant-page-header-heading-left a.header-link {
  display: flex;
  align-items: center;
  color: #137CBD;
}
header .page-header .ant-page-header-heading-left a.header-link img.header-logo {
  padding: 4px;
  margin-left: 20px;
  margin-right: 20px;
  max-height: 60px;
}
header .page-header .ant-page-header-heading-extra {
  align-self: center;
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/Header/Header.less"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,gCAAA;EACA,wCAAA;EAEA,cAAA;EACA,gBAAA;AAAF;AANA;EASI,mBAAA;AAAJ;AATA;EAYM,aAAA;EACA,mBAAA;EACA,cAAA;AAAN;AAdA;EAiBQ,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AApBA;EA0BI,kBAAA;EACA,kBAAA;AAHJ","sourcesContent":["header .page-header {\n  padding: 0;\n  border-bottom: 2px solid @primary-color;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);\n  font-size: 1.2em;\n  color: @primary-color;\n  font-size: 1.2em;\n\n  .ant-page-header-heading-left {\n    margin-block: unset;\n\n    a.header-link {\n      display: flex;\n      align-items: center;\n      color: @primary-color;\n\n      img.header-logo {\n        padding: 4px;\n        margin-left: 20px;\n        margin-right: 20px;\n        max-height: 60px;\n      }\n    }\n  }\n\n  .ant-page-header-heading-extra {\n    align-self: center;\n    margin-right: 20px;\n  }\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
